export { fromNumber };
export { split };
export { join };

function fromNumber(x: number): string {
    return x.toString();
}

function split(char: string, str: string): string[] {
    return str.split(char);
}

function join(char: string, xs: string[]): string {
    return xs.join(char);
}
